import React, { useState, useEffect } from "react";

const NotFound = () => {
  const [count, setCount] = useState(10);

  useEffect(() => {
    // Countdown timer for auto-redirect
    const timer = count > 0 && setInterval(() => setCount(count - 1), 1000);
    if (count === 0) {
      window.location.href = "/login"; // Redirect to homepage when countdown reaches zero
    }
    return () => clearInterval(timer);
  }, [count]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-white rounded-lg shadow-xl overflow-hidden">
        <div className="p-5 bg-indigo-600">
          <div className="text-center">
            <h1 className="text-9xl font-bold text-white animate-pulse">404</h1>
          </div>
        </div>

        <div className="p-6 space-y-6">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              Page Not Found
            </h2>
            <p className="text-gray-600 mb-6">
              Oops! The page you're looking for doesn't exist or has been moved.
            </p>

            <div className="h-1 w-full bg-gray-200 rounded">
              <div
                className="h-1 bg-indigo-600 rounded transition-all duration-300 ease-out"
                style={{ width: `${count * 10}%` }}
              ></div>
            </div>

            <p className="mt-4 text-sm text-gray-500">
              Redirecting to homepage in {count} seconds...
            </p>
          </div>

          <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2">
            <a
              href="/"
              className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-4 rounded-lg text-center transition-colors duration-300"
            >
              Return Home
            </a>
            <button
              onClick={() => window.history.back()}
              className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-3 px-4 rounded-lg text-center transition-colors duration-300"
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
